<template>
  <div>
    <div>
      <v-layout wrap>
        <v-flex xs9 class="pl-2">
          <h1 style="color:#66a6fe">
            Chatday By
            <img class="partner-logo" src="/static/img/readyplanet.png" style="height: 25px" />
            <v-chip color="red" class="white--text" disabled small>{{ $t('New') }}</v-chip>
          </h1>
        </v-flex>
        <v-flex class="text-xs-right">
          <v-btn
            class="partner-logo"
            v-if="!isEdit"
            fab
            @click="isEdit = true"
            outline
            small
            color="primary"
          >
            <v-icon>edit</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs12 class="pl-2">
          <ul class="list-group vertical-steps">
            <li class="list-group-item">
              {{
                $t(
                  'Create chatbot on website. Register new account with Chatday system for free now.'
                )
              }}
              <div>
                <v-btn
                  class="py-2"
                  color="primary"
                  depressed
                  style="display: inline-block"
                  href="https://www.readyplanet.com/17331353/readyplanet-marketing-platform?utm_source=zwiz&utm_medium=referral&utm_campaign=<chatday>"
                  target="_BLANK"
                  >{{ $t('Register CHATDAY') }}</v-btn
                >
              </div>
            </li>
            <li class="list-group-item">
              <div class="form-control" :class="{ 'has-error': errors.has('token') }">
                <label for="text">{{ $t('Token') }}</label>
                <div v-if="isEdit">
                  <textarea
                    class="form-control"
                    rows="5"
                    maxlength="600"
                    v-model="token"
                    style="resize:vertical;min-height: 90px"
                    :data-vv-as="$t('Token')"
                    name="token"
                    v-validate="{ required: true }"
                    :placeholder="'Token'"
                  ></textarea>

                  <span class="text-error" v-if="errors.has('token')">
                    {{ errors.first('token') }}
                  </span>
                </div>
                <div v-else>
                  <h3 style="word-break: break-all;">{{ token ? token : '-' }}</h3>
                </div>
              </div>
            </li>
            <li class="list-group-item" v-if="token">
              <div>
                <label for>Webhook Url</label>
                <textarea
                  class="form-control pa-1"
                  style="resize: vertical;min-height: 90px;background: #eee"
                  onclick="this.select()"
                  readonly="true"
                  :value="`${config.serverUrl}webhookreadyplanet`"
                >
                </textarea>
              </div>
            </li>
          </ul>
        </v-flex>
      </v-layout>
      <div class="text-xs-center" style="margin-top: 15px;" v-if="isEdit">
        <v-btn outline color="grey" @click="cancelEdit">{{ $t('cancel') }}</v-btn>
        <v-btn depressed color="primary" @click="saveEdit">{{ $t('Save') }}</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/config'
import { mapGetters } from 'vuex'
import api from '@/api'

export default {
  data() {
    return {
      isEdit: false,
      token: '',
      config: config
    }
  },
  mounted() {
    this.token = this.selectedBot.chatday_token
    // if (this.token == null || this.token == '') {
    //   this.isEdit = true
    // }
  },
  computed: {
    ...mapGetters({
      currentLang: 'currentLang',
      selectedBot: 'selectedBot'
    })
  },
  methods: {
    cancelEdit() {
      this.token = this.selectedBot.chatday_token
      this.isEdit = false
    },
    async saveEdit() {
      let result = await this.$validator.validateAll()
      if (!result) {
        // do stuff if not valid.
        this.goToErrorInput()
        return false
      }

      let status = await this.checkChatdayToken()
      if (status) {
        this.$swal.fire({
          title: this.$t('Successfully'),
          type: 'success'
        })
        this.isEdit = false
      } else {
        this.$swal.fire({
          title: this.$t('Unsuccessful'),
          type: 'error'
        })
      }
    },
    checkChatdayToken() {
      var vm = this
      return new Promise((resolve, reject) => {
        var data = {
          pageid: vm.selectedBot.pageid,
          chatday_token: vm.token
        }
        api.checkChatdayToken(data, (error, response) => {
          if (error) reject(error)

          if (response.responsecode == 200 && response.status == 'pass') resolve(true)
          else resolve(false)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/billing/Chatday.vue